(function () {
  let handled = false;

  function t(key, fallback) {
    return window.ReadcrumbsI18n?.[key] || fallback;
  }

  function loginUrl() {
    const returnTo = window.location.pathname + window.location.search + window.location.hash;
    const role = window.currentUserRole;
    const base = role === 'author' ? '/authors/login' : '/auth/google_oauth2';
    return base + '?redirect_to=' + encodeURIComponent(returnTo);
  }

  function csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]');
    return meta && meta.content;
  }

  function isSameOrigin(url) {
    try {
      return new URL(url, window.location.href).origin === window.location.origin;
    } catch {
      return true;
    }
  }

  // Set by the layout only when the page was rendered for a signed-in user
  // (see application.html.erb). A 401 with no authenticated session behind
  // it is not an expiration — most commonly an anonymous shared reader
  // hitting a login-gated endpoint — so it must never trigger this flow.
  function wasAuthenticatedOnLoad() {
    return typeof window.currentUserRole === 'string' && window.currentUserRole.length > 0;
  }

  function handleSessionExpired() {
    if (handled || !wasAuthenticatedOnLoad()) return;
    handled = true;
    alert(t('session_expired', 'Your session has expired due to inactivity. Please log in again to continue.'));
    window.location.href = loginUrl();
  }

  const origFetch = window.fetch;
  window.fetch = function (input, init = {}) {
    const req = new Request(input, init);

    let request = req;

    if (isSameOrigin(req.url)) {
      const hdrs = new Headers(req.headers || {});
      const creds = req.credentials || 'same-origin';

      if (!['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes((req.method || 'GET').toUpperCase())) {
        const token = csrfToken();
        if (token && !hdrs.has('X-CSRF-Token')) hdrs.set('X-CSRF-Token', token);
        if (!hdrs.has('Content-Type') && !(init.body instanceof FormData)) {
          hdrs.set('Content-Type', 'application/json');
        }
      }

      // Send the Request whose headers we inspected. In particular, do not pass
      // the original FormData to fetch again: constructing `req` serialized it
      // with a boundary, and a second serialization can choose a new boundary
      // while retaining the first one in Content-Type.
      request = new Request(req, { credentials: creds, headers: hdrs });
    }

    return origFetch(request).then((resp) => {
      if (isSameOrigin(resp.url || input) && resp.status === 401) handleSessionExpired();
      return resp;
    });
  };

  document.addEventListener('turbo:before-fetch-request', (event) => {
    const { fetchOptions } = event.detail;
    fetchOptions.credentials = 'same-origin';
    const token = csrfToken();
    if (token && fetchOptions.method && fetchOptions.method !== 'GET') {
      fetchOptions.headers = fetchOptions.headers || {};
      if (!('X-CSRF-Token' in fetchOptions.headers)) fetchOptions.headers['X-CSRF-Token'] = token;
    }
  });

  document.addEventListener('turbo:before-fetch-response', (event) => {
    const { fetchResponse } = event.detail;
    if (fetchResponse && fetchResponse.response && fetchResponse.response.status === 401) {
      handleSessionExpired();
    }
  });

  if (window.$) {
    $.ajaxSetup({
      xhrFields: { withCredentials: true },
      beforeSend: function (xhr, settings) {
        const method = (settings.type || 'GET').toUpperCase();
        if (!['GET', 'HEAD', 'OPTIONS', 'TRACE'].includes(method)) {
          const token = csrfToken();
          if (token) xhr.setRequestHeader('X-CSRF-Token', token);
        }
      },
    });

    $(document).ajaxError((_, xhr) => {
      if (xhr.status === 401) handleSessionExpired();
    });
  }
})();
